import React, {useState} from 'react'

import {
  Alert,
  AppWrapper,
  Button,
  ComponentColor,
  ComponentSize,
  ComponentStatus,
  FlexBox,
  FlexDirection,
  FunnelPage,
  IconFont,
  Panel,
  RemoteDataState,
} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'

import axios from 'axios'
import {getCSRFToken} from 'js/utils/csrf_token'
import FunnelSubHeader from '../shared/FunnelSubheader'
import FunnelHeader from '../shared/FunnelHeader'
import {privateAPI} from 'js/client'

interface Props {
  email: string
}

const EmailVerify = ({email}: Props): JSX.Element => {
  const [resendingState, setResendingState] = useState(
    RemoteDataState.NotStarted
  )

  const handleResendEmail = async () => {
    setResendingState(RemoteDataState.Loading)

    try {
      const url = privateAPI('verify/resend')
      const {status} = await axios.post(url, {
        _csrf_token: getCSRFToken(),
      })

      if (status !== 204) {
        setResendingState(RemoteDataState.Error)
      }

      setResendingState(RemoteDataState.Done)
    } catch {
      setResendingState(RemoteDataState.Error)
    }
  }

  const alertText =
    resendingState === RemoteDataState.Error
      ? 'The email could not be sent at this time.'
      : 'We have attempted to resend the email. Please check your email.'
  const alertIcon =
    resendingState === RemoteDataState.Error
      ? IconFont.AlertTriangle
      : IconFont.CheckMark_New
  const alertColor =
    resendingState === RemoteDataState.Error
      ? ComponentColor.Danger
      : ComponentColor.Success

  const showAlert =
    resendingState === RemoteDataState.Done ||
    resendingState === RemoteDataState.Error

  const buttonStatus =
    resendingState === RemoteDataState.Loading
      ? ComponentStatus.Loading
      : ComponentStatus.Default

  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<LogoWithCubo />}>
        <FlexBox direction={FlexDirection.Column} margin={ComponentSize.Medium}>
          <FunnelHeader text="Email Verification" />
          <FunnelSubHeader
            text="We just need to make sure you're not a robot, but if you are, no
            hard feelings."
          />
          <FlexBox
            direction={FlexDirection.Column}
            margin={ComponentSize.Medium}
            className="sign-up--splash"
          >
            {showAlert && (
              <Alert color={alertColor} icon={alertIcon}>
                {alertText}
              </Alert>
            )}
            <Panel>
              <Panel.Body size={ComponentSize.Large}>
                <span>
                  We've sent an email to <strong>{email}</strong> with a
                  verification link. <br /> Please click the link to continue.
                </span>
              </Panel.Body>
            </Panel>
          </FlexBox>
          <p>Not receiving your verification email?</p>
          <Button
            titleText="Resend Email"
            text="Resend Email"
            onClick={handleResendEmail}
            status={buttonStatus}
            color={ComponentColor.Primary}
            size={ComponentSize.Medium}
          />
        </FlexBox>
      </FunnelPage>
    </AppWrapper>
  )
}

export default EmailVerify
